import { computed, ref } from "vue"
import { countVisibleItems, filterItemsByLetter, scrollToLetter } from "../utils/filterable_list"

export function useFilterableList(itemsByLetter) {
  const query = ref("")
  const letters = "ABCDEFGHIJKLMNOPQRSTUVWXYZ".split("")

  const filteredGroups = computed(() => filterItemsByLetter(itemsByLetter, query.value))
  const visibleCount = computed(() => countVisibleItems(filteredGroups.value))
  const showNoResults = computed(() => visibleCount.value === 0)

  const letterHasItems = (letter) => Boolean(filteredGroups.value[letter]?.length)

  function jumpToLetter(event, letter) {
    event.preventDefault()
    if (!letterHasItems(letter)) return
    scrollToLetter(letter)
  }

  return {
    query,
    letters,
    filteredGroups,
    visibleCount,
    showNoResults,
    letterHasItems,
    jumpToLetter,
  }
}
